@if (isOpen && cupom; as c) {
  <div class="modal-overlay" role="dialog" aria-modal="true" data-testid="cupom-overlay">
    <div class="modal-dialog cupom-dialog" data-testid="cupom-modal" (click)="$event.stopPropagation()">
      <div class="modal-content">
        <div class="modal-header">
          <h2 class="modal-title d-flex align-items-center">
            <i class="bi bi-receipt me-2"></i> Cupom da Venda
          </h2>
        </div>
        <div class="modal-body">
          <div class="cupom-papel" data-testid="cupom-papel">
            @if (c.empresa; as emp) {
              <div class="cupom-empresa" data-testid="cupom-empresa">
                @if (emp.nomeFantasia?.trim()) {
                  <div class="cupom-empresa__fantasia" data-testid="cupom-empresa-fantasia">{{ emp.nomeFantasia }}</div>
                }
                @if (emp.razaoSocial?.trim()) {
                  <div data-testid="cupom-empresa-razao">{{ emp.razaoSocial }}</div>
                }
                @if (emp.cnpj?.trim()) {
                  <div data-testid="cupom-empresa-cnpj">CNPJ {{ formatarCnpj(emp.cnpj) }}</div>
                }
                @if (emp.inscricaoEstadual?.trim()) {
                  <div data-testid="cupom-empresa-ie">IE {{ emp.inscricaoEstadual!.trim() }}</div>
                }
                @if (montarEnderecoEmpresa(emp); as end) {
                  <div data-testid="cupom-empresa-endereco">{{ end }}</div>
                }
                @if (emp.telefone?.trim()) {
                  <div data-testid="cupom-empresa-telefone">{{ formatarTelefone(emp.telefone) }}</div>
                }
                @if (emp.email?.trim()) {
                  <div data-testid="cupom-empresa-email">{{ emp.email }}</div>
                }
              </div>
            }
            <div class="cupom-aviso" data-testid="cupom-aviso-nao-fiscal">DOCUMENTO NÃO FISCAL<br>SEM VALOR FISCAL</div>
            <div class="cupom-centro">Comprovante de Venda</div>
            <hr>
            <div class="cupom-linha"><span>Referência</span><span>#{{ c.numeroReferencia }}</span></div>
            <div class="cupom-linha"><span>Emissão</span><span>{{ formatarDataHora(c.emitidoEm) }}</span></div>
            @if (c.nomeVendedor) {
              <div class="cupom-linha"><span>Vendedor</span><span>{{ c.nomeVendedor }}</span></div>
            }
            <hr>
            <div data-testid="cupom-cliente">Cliente: {{ c.nomeCliente }}</div>
            @if (c.cpfCnpjCliente) {
              <div data-testid="cupom-documento">CPF/CNPJ: {{ c.cpfCnpjCliente }}</div>
            }
            <hr>
            <div class="cupom-linha"><span>Subtotal</span><span>{{ c.subtotal | currency:'BRL' }}</span></div>
            <div class="cupom-linha"><span>Desconto</span><span>- {{ c.desconto | currency:'BRL' }}</span></div>
            <div class="cupom-linha cupom-total"><span>TOTAL</span><span>{{ c.valorTotal | currency:'BRL' }}</span></div>
            <hr>
            <div class="cupom-linha"><span>Tipo</span><span>{{ c.tipoVenda }}</span></div>
            <div class="cupom-linha"><span>Forma</span><span>{{ c.formaPagamento }}</span></div>
            @if (c.bandeira) {
              <div class="cupom-linha"><span>Bandeira</span><span>{{ c.bandeira }}</span></div>
            }
            @if (c.numParcelas > 1) {
              <div class="cupom-linha"><span>Parcelas</span><span>{{ c.numParcelas }}x</span></div>
            }
            @if (c.valorEntrada) {
              <div class="cupom-linha"><span>Entrada</span><span>{{ c.valorEntrada | currency:'BRL' }}</span></div>
            }
            @if (c.previsaoEntrega) {
              <div class="cupom-linha"><span>Previsão entrega</span><span>{{ formatarData(c.previsaoEntrega) }}</span></div>
            }
            <hr>
            <div class="cupom-aviso">ESTE DOCUMENTO NÃO É UM CUPOM FISCAL</div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-outline-secondary" data-testid="btn-sair-cupom" (click)="sair()">Sair</button>
          <button type="button" class="btn btn-primary" data-testid="btn-imprimir-cupom" (click)="imprimir()">
            <i class="bi bi-printer me-1"></i> Imprimir
          </button>
        </div>
      </div>
    </div>
  </div>
}
